import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ServiceModel } from 'src/app/models/service-model';
import { ServiceService } from 'src/app/services/service.service';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'api-key-view',
  templateUrl: './api-key-view.component.html',
  styleUrls: ['./api-key-view.component.scss']
})
export class ApiKeyComponent implements OnInit {
  public apikey: string;
  constructor(private _modal: NgbActiveModal, private _modalService: NgbModal) { }

  async ngOnInit(): Promise<void> {
  }

  public close() {
    this._modal.close();
  }

  public openCornfirmation(messages: string) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = "OK"
    dialogRef.componentInstance.title = "Merchant Config Cannot Be Removed"
    dialogRef.componentInstance.message = "This Merchant Config is currently in use and cannot be deleted.<br/><br/><b>Merchants using config:</b>"
    dialogRef.componentInstance.listMessage = messages;
  }
}
